import { DynamicGrid } from "../../components";
import MovieCardSkeleton from "./MovieCardSkeleton";

function MovieCardListSkeleton({
  grid,
}: {
  grid?: {
    md?: number;
    base?: number;
    lg?: number;
  };
}) {
  return (
    <DynamicGrid
      baseChildKey="movie__skeleton__child__"
      cloneChildToFitSize
      grid={grid}
    >
      <MovieCardSkeleton />
    </DynamicGrid>
  );
}

export default MovieCardListSkeleton;
